import { useState, useCallback } from 'react'

import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'

import useDApp from 'contexts/Web3'
import { LinkCashback, LinkKnights } from 'routes'

import FightingPanel from 'containers/FightingPanel'
import Header from 'containers/Header'
import Links from 'containers/Links'

import CloseButton from 'components/CloseButton'
import ErrorMessage from 'components/ErrorMessage'
import { Altas } from 'components/ExternalLinks'
import Help from 'components/Help'
import { Pennant, RoundTable } from 'components/Icons/PngIcon'
import { SlideUp } from 'components/Transitions'

/* eslint-disable-next-line import/no-webpack-loader-syntax */
import imgHelp from '!!file-loader!assets/help-main.png'
import './GameView.scss'
import useMount from 'hooks/useMount'

const iconStyles = {
  width: 35,
  height: 35,
}

const dialogPaperProps = {
  sx: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
}

function GameView() {
  const { error, actions } = useDApp()
  const [showAtlas, setAtlasView] = useState(false)

  const openAtlasView = useCallback(() => setAtlasView(true), [])
  const closeAtlasView = useCallback(() => setAtlasView(false), [])

  useMount(() => {
    setTimeout(actions.refreshGameInfo, 1000)
  })

  return (
    <Container className="game-view" maxWidth="sm" disableGutters>
      <Stack position="absolute" top={0} left={0} zIndex={100} pt={2.5}>
        <LinkKnights>
          <IconButton size="large">
            <RoundTable variant="square" sx={iconStyles} />
          </IconButton>
        </LinkKnights>

        <LinkCashback>
          <IconButton size="large">
            <Pennant variant="square" sx={iconStyles} />
          </IconButton>
        </LinkCashback>
      </Stack>

      <Stack position="absolute" top={0} right={0} zIndex={100} pt={2.5}>
        <Help image={imgHelp} />
        <Altas onClick={openAtlasView}>Map</Altas>
      </Stack>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={showAtlas}
        onClose={closeAtlasView}
        TransitionComponent={SlideUp}
        PaperProps={dialogPaperProps}
        sx={{ backgroundColor: '#cfbc81cc' }}
      >
        <Box display="flex" justifyContent="end">
          <CloseButton onClick={closeAtlasView} />
        </Box>
        <Links />
      </Dialog>

      <Header position="absolute" left={60} right={60} top={10} />

      <FightingPanel />

      <ErrorMessage open={Boolean(error)} onClose={actions.clearError}>
        <>{error ?? ''}</>
      </ErrorMessage>
    </Container>
  )
}

export default GameView
